import { LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Export extends VuexModule {
  public exportLoadingstatus: LoadingStatusType = LoadingStatusType.None;

  @Mutation
  public SetExportLoadingstatus(status: LoadingStatusType) {
    this.exportLoadingstatus = status;
  }

  @Action
  public DoExportTaxWhtCertificatePndReport(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);
    API.ExportService.DoExportTaxWhtCertificatePndReport(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.error;
      }

      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: typeMessage,
        },
        { root: true }
      );

      this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  public DoExportTaxTransactionPP30Report(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);
    API.ExportService.DoExportTaxTransactionPP30Report(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.error;
      }

      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: typeMessage,
        },
        { root: true }
      );

      this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  public DoExportTaxWhtCertificateReport(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);
    API.ExportService.DoExportTaxWhtCertificateReport(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.error;
      }

      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: typeMessage,
        },
        { root: true }
      );

      this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  public DoExportTaxTransactionReport(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);
    API.ExportService.DoExportTaxTransactionReport(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.error;
      }

      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: typeMessage,
        },
        { root: true }
      );

      this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  public DoExportContact(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);
    API.ExportService.DoExportContact(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.error;
      }

      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: typeMessage,
        },
        { root: true }
      );

      this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
}
